






































import Vue from 'vue'
import Component from 'vue-class-component'
import { namespace, State } from 'vuex-class'
import { UserData } from '../store/profile/types'
import { DataState } from '../store/data/types'

const profile = namespace('profile')

@Component
export default class Notifications extends Vue {
  @State('data') private data!: DataState;

  @profile.State('data') private userData!: UserData;

  // eslint-disable-next-line
  @profile.Action('updateUserData') updateUserData: any;

  // eslint-disable-next-line
  @profile.Action('saveToFirestore') saveToFirestore: any;

  contactlensLeft = -1
  contactlensRight = -1
  accepted = false

  mounted () {
    if (this.$route.params && this.$route.params.contactlensId) {
      this.contactlensLeft = Number.parseInt(this.$route.params.contactlensId)
      this.contactlensRight = Number.parseInt(this.$route.params.contactlensId)
    }
  }

  get contactlenses () {
    return this.data.contactlenses
  }

  // used to control enabled/disabled behaviour of CTA-Button
  get isEnabled () {
    return this.accepted && (this.contactlensLeft > -1 || this.contactlensRight > -1)
  }

  async addNotification () {
    this.$router.push({
      name: 'NotificationThankYou',
      params: {
        contactlensIdLeft: '' + this.contactlensLeft,
        contactlensIdRight: '' + this.contactlensRight
      }
    })
  }
}
